import Core          from '@/core/Core';
import Utils         from '@/core/utils/Utils';
import BaseEntity    from '@/core/misc/BaseEntity';
import DateRange     from '@/core/types/DateRange';
import DateSimple    from '@/core/types/DateSimple';
import NumericRange  from '@/core/types/NumericRange';
import Price         from '@/core/types/Price';

import Title_ru_RU_Class from '@/core/misc/decorators/Title_ru_RU_Class';

import type SupplyOffer   from '@/domains/SupplyOffers/SupplyOffer';
import SupplyOffersService from '@/domains/SupplyOffers/SupplyOffersService';
import BudgetPrice         from '@/domains/BudgetPrices/BudgetPrice';
import Title_ru_RU from "@/core/misc/decorators/Title_ru_RU";
import TYPES from "@/core/services/Changelogs/types";

@Title_ru_RU_Class('Тариф')
class SupplyOfferTariff extends BaseEntity {

	/** Диапазон количества: от и до */
  @Title_ru_RU('Диапазон количества', TYPES.INT_RANGE)
  public qty: NumericRange;

	/** Цена. Валюта берётся с оффера — у тарифа своей валюты нет */
  @Title_ru_RU('Цена', TYPES.PRICE)
  public price: Price;

	/** Период действия цены */
  @Title_ru_RU('Период действия цены', TYPES.DATE_RANGE)
	public actualFor: DateRange = new DateRange();

	// фронтовое поле
	public _tempId: string;

	static fromServer(data: any, tariff: SupplyOfferTariff = new SupplyOfferTariff()): SupplyOfferTariff {
		super.fromServer(data, tariff);

		tariff.qty       = Core.utils.hydrate(data.qty, NumericRange.fromServer)!;
		tariff.actualFor = Core.utils.hydrate(data.actualFor, DateRange.fromServer)!;
		tariff.price     = Core.utils.hydrate(data.price, Price.fromServer)!;

		return tariff;
	}

	/**
	 * Создаёт пустой тариф.
	 * Левая граница qty берётся из конца предыдущего тарифа + 1.
	 */
	static getEmpty(supplyOffer: SupplyOffer, previousTariff?: SupplyOfferTariff | null): SupplyOfferTariff {
		const result = new this();

		result._tempId = crypto.randomUUID();

		let leftEdgeQty;

		if (previousTariff) {
			leftEdgeQty = (Utils.number.toNumber(previousTariff.qty?.end) ?? 0) + 1;
		}
		else {
			leftEdgeQty = undefined;
		}

		result.qty = new NumericRange(leftEdgeQty, undefined);

		result.actualFor.start = DateSimple.today();

		return result;
	}

	get isExpired() {
		return Core.utils.date.dateDifference(this.actualFor.start, DateSimple.today()) > SupplyOffersService.PRICE_EXPIRATION_DAYS;
	}

	isLessOrEqualBudgetPrice(budgetPrice: BudgetPrice): boolean {
		// бюджетная цена в валюте оффера
		// tariff.price тоже в валюте оффера
		return this.price.lessThan(budgetPrice.price) || this.price.equals(budgetPrice.price);
	}

  private isSameTariff(other: SupplyOfferTariff): boolean {
    const isEqualQty = this.qty?.equals(other.qty);
    const isEqualPrice = this.price?.equals(other.price);
    const isEqualActualFor = this.actualFor.equals(other.actualFor);


    return isEqualQty && isEqualPrice && isEqualActualFor;
  }
}

export default SupplyOfferTariff;
